import cc from 'classcat';

import { FormikSimplifiedInput as SimplifiedInput } from '../../Form';

import styles from './styles.module.scss';

export default function PasswordInputs({
  email,
  password,
  passwordConfirmation,
  isSubmitting,
  heading: Heading = PasswordInputs.DefaultHeading,
  rules: Rules = PasswordInputs.PasswordRules,
  className,
}) {
  return (
    <section className={cc([styles.passwordForm, className])}>
      <Heading />
      <div className={styles.emailContainer}>
        <SimplifiedInput
          autoComplete="email"
          value={email}
          name="email"
          type="email"
          disabled={isSubmitting}
          placeholder="Email address"
        />
      </div>
      <SimplifiedInput
        autoComplete="new-password"
        value={password}
        name="password"
        type="password"
        placeholder="Create password"
        disabled={isSubmitting}
      />
      <SimplifiedInput
        autoComplete="new-password"
        value={passwordConfirmation}
        name="passwordConfirmation"
        type="password"
        placeholder="Re-enter password"
        disabled={isSubmitting}
      />
      <Rules />
    </section>
  );
}

/*
Exposed separately to allow users of PasswordInputs to include the stock
header in their own embellished header components, e.g.

  const Head = () => (
      <PasswordInputs.DefaultHeading>
        <span>other stuff</span>
      </PasswordInputs.DefaultHeading>
  )

  <PasswordInputs heading={Head} />

*/
PasswordInputs.DefaultHeading = ({ className, children }) => (
  <header className={cc([styles.passwordHeader, className])}>
    <h2>Create a password</h2>
    {children}
  </header>
);

PasswordInputs.PasswordRules = ({ className, children }) => (
  <>
    <p className={cc([styles.passwordRules, className])}>
      *Password should be 8 characters or longer.
    </p>
    {children}
  </>
);
